export const MICROSOFT_HARDWARE = [
{
    id: "xbox-series",
    name: "Xbox Series",
    brand: "Microsoft",
    category: "Xbox",
    type: "console",
    variants: [
      {
        id: "xbox-series-x",
        name: "Xbox Series X",
        versions: [
          {
            id: "xbox-series-x-1tb",
            name: "Xbox Series X 1 To",
            storage: "1 To",
            disc: true,
            image: "/images/consoles/xbox-series-x.png",
          },
          {
            id: "xbox-series-x-digital-1tb",
            name: "Xbox Series X Digital 1 To",
            storage: "1 To",
            disc: false,
            image: "/images/consoles/xbox-series-x-digital.png",
          },
          {
            id: "xbox-series-x-2tb",
            name: "Xbox Series X 2 To",
            storage: "2 To",
            disc: true,
            image: "/images/consoles/xbox-series-x-2tb.png",
          },
        ],
      },
      {
        id: "xbox-series-s",
        name: "Xbox Series S",
        versions: [
          {
            id: "xbox-series-s-512",
            name: "Xbox Series S 512 Go",
            storage: "512 Go",
            disc: false,
            image: "/images/consoles/xbox-series-s.png",
          },
          {
            id: "xbox-series-s-1tb",
            name: "Xbox Series S 1 To",
            storage: "1 To",
            disc: false,
            image: "/images/consoles/xbox-series-s-1tb.png",
          },
        ],
      },
    ],
  },

  {
    id: "xbox-one",
    name: "Xbox One",
    brand: "Microsoft",
    category: "Xbox",
    type: "console",
    variants: [
      {
        id: "xbox-one-fat",
        name: "Xbox One",
        versions: [
          {
            id: "xbox-one-500",
            name: "Xbox One 500 Go",
            storage: "500 Go",
            disc: true,
            image: "/images/consoles/xbox-one.png",
          },
          {
            id: "xbox-one-1tb",
            name: "Xbox One 1 To",
            storage: "1 To",
            disc: true,
            image: "/images/consoles/xbox-one.png",
          },
        ],
      },
      {
        id: "xbox-one-s",
        name: "Xbox One S",
        versions: [
          {
            id: "xbox-one-s-500",
            name: "Xbox One S 500 Go",
            storage: "500 Go",
            disc: true,
            image: "/images/consoles/xbox-one-s.png",
          },
          {
            id: "xbox-one-s-1tb",
            name: "Xbox One S 1 To",
            storage: "1 To",
            disc: true,
            image: "/images/consoles/xbox-one-s.png",
          },
          {
            id: "xbox-one-s-digital-1tb",
            name: "Xbox One S All-Digital 1 To",
            storage: "1 To",
            disc: false,
            image: "/images/consoles/xbox-one-s-digital.png",
          },
        ],
      },
      {
        id: "xbox-one-x",
        name: "Xbox One X",
        versions: [
          {
            id: "xbox-one-x-1tb",
            name: "Xbox One X 1 To",
            storage: "1 To",
            disc: true,
            image: "/images/consoles/xbox-one-x.png",
          },
        ],
      },
    ],
  },

  {
  id: "xbox-360",
  name: "Xbox 360",
  brand: "Microsoft",
  type: "console",
  category: "Xbox",
  variants: [
    {
      id: "xbox-360-fat",
      name: "Xbox 360",
      versions: [
        { id: "xbox-360-arcade", name: "Xbox 360 Arcade", storage: "256 Mo", disc: true, image: "/images/consoles/xbox-360-arcade.png" },
        { id: "xbox-360-premium-20", name: "Xbox 360 Premium 20 Go", storage: "20 Go", disc: true, image: "/images/consoles/xbox-360-fat.png" },
        { id: "xbox-360-elite-120", name: "Xbox 360 Elite 120 Go", storage: "120 Go", disc: true, image: "/images/consoles/xbox-360-elite.png" },
      ],
    },
    {
      id: "xbox-360-s",
      name: "Xbox 360 S",
      versions: [
        { id: "xbox-360-s-4", name: "Xbox 360 S 4 Go", storage: "4 Go", disc: true, image: "/images/consoles/xbox-360-slim-4gb.png" },
        { id: "xbox-360-s-250", name: "Xbox 360 S 250 Go", storage: "250 Go", disc: true, image: "/images/consoles/xbox-360-slim-250gb.png" },
      ],
    },
    {
      id: "xbox-360-e",
      name: "Xbox 360 E",
      versions: [
        { id: "xbox-360-e-4", name: "Xbox 360 E 4 Go", storage: "4 Go", disc: true, image: "/images/consoles/xbox-360-e.png" },
        { id: "xbox-360-e-250", name: "Xbox 360 E 250 Go", storage: "250 Go", disc: true, image: "/images/consoles/xbox-360-e.png" },
      ],
    },
  ],
},

{
  id: "xbox-original",
  name: "Xbox",
  brand: "Microsoft",
  type: "console",
  category: "Xbox",
  variants: [
    {
      id: "xbox-original-standard",
      name: "Xbox",
      versions: [
        {
          id: "xbox-original",
          name: "Xbox Original",
          storage: "8 Go",
          disc: true,
          image: "/images/consoles/xbox-original.png",
        },
      ],
    },
  ],
},
]